// @flow

import * as React from 'react';

import Tab from './Tab';

type Props = {
  children: React.Node
};

class TabControl extends React.PureComponent<Props> {
  static Tab = Tab;

  render() {
    return (
      <ul className="flex list-style-none p0 m0 mb4 border-bottom border-gray">{this.props.children}</ul>
    );
  }
}

export default TabControl;
